import React, { useState, useEffect, useCallback } from 'react';
import { initializeApp } from 'firebase/app';
import { getAuth, signInAnonymously, onAuthStateChanged, signInWithEmailAndPassword, signOut, signInWithCustomToken } from 'firebase/auth';
import { getFirestore, doc, setDoc, onSnapshot, collection, getDocs, getDoc, deleteDoc } from 'firebase/firestore';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBBf9u7TV69rzLfhZC9V1hrCkvTvDGKrvM",
  authDomain: "ahead-marketing-client-app.firebaseapp.com",
  projectId: "ahead-marketing-client-app", // VERIFY THIS EXACTLY MATCHES YOUR FIREBASE PROJECT ID
  storageBucket: "ahead-marketing-client-app.firebasestorage.app",
  messagingSenderId: "1008127401938",
  appId: "1:1008127401938:web:2f0d98bd6f89eb0aa8720b"
};

// Initialize Firebase App
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

// 🚨 CRITICAL FIX: Add the Admin UID constant. This MUST match the UID under which your client data is stored
const ADMIN_UID = 'F38bcVCLiJXLe1hFUHl77FKWBlI3';


// Define the specific stages for each service type
const SERVICE_STAGES = {
    'Web Design': ["Onboarding", "Design", "SEO setup & launch!", "Post launch"],
    'SEO': ["Setup", "Strategy & content", "Optimisations", "Reporting"],
    'PPC': ["Setup", "Strategy & launch", "Monitoring", "Optimisation and reporting"],
    'Meta Ads': ["Setup", "Strategy & launch", "Monitoring", "Optimisation & reporting"]
};

// Define service-specific branding colors
const SERVICE_COLORS = {
    'Web Design': '#7D190D', // Dark Reddish-Brown
    'SEO': '#1A4027',    // Dark Green
    'PPC': '#D4A437',    // Golden Yellow
    'Meta Ads': '#030541'  // Very Dark Dark Blue
};

// Define default tasks for each stage of each service type
const DEFAULT_SERVICE_TASKS = {
    'Web Design': [
        { name: 'Onboarding', tasks: [
            { id: 'wd_o1', name: 'Concept meeting', completed: false },
            { id: 'wd_o2', name: 'Competitor analysis', completed: false },
            { id: 'wd_o3', name: 'Wireframe', completed: false },
            { id: 'wd_o4', name: 'Sitemap', completed: false },
            { id: 'wd_o5', name: 'Branding', completed: false },
            { id: 'wd_o6', name: 'Domain registration', completed: false },
            { id: 'wd_o7', name: 'Hosting setup', completed: false },
            { id: 'wd_o8', name: 'Email setup', completed: false },
        ] },
        { name: 'Design', tasks: [
            { id: 'wd_d1', name: 'Add content', completed: false },
            { id: 'wd_d2', name: 'Brevo setup', completed: false },
            { id: 'wd_d3', name: 'Mailerlite setup', completed: false },
            { id: 'wd_d4', name: 'Responsive testing', completed: false },
        ] },
        { name: 'SEO setup & launch!', tasks: [
            { id: 'wd_sl1', name: 'Favicon', completed: false },
            { id: 'wd_sl2', name: 'Header tag optimisation', completed: false },
            { id: 'wd_sl3', name: 'Metadata updates', completed: false },
            { id: 'wd_sl4', name: 'Citations', completed: false },
            { id: 'wd_sl5', name: 'GA4', completed: false },
            { id: 'wd_sl6', name: 'Business schema', completed: false },
            { id: 'wd_sl7', name: 'GSC & XML sitemap submitted', completed: false },
            { id: 'wd_sl8', name: 'GTM conversion tracking', completed: false },
            { id: 'wd_sl9', name: 'HTML sitemap', completed: false },
            { id: 'wd_sl10', name: 'Launch!', completed: false },
        ] },
        { name: 'Post launch', tasks: [
            { id: 'wd_pl1', name: 'Ongoing management', completed: false },
        ] },
    ],
    'SEO': [
        { name: 'Setup', tasks: [
            { id: 'seo_s1', name: 'Onboarding', completed: false },
            { id: 'seo_s3', name: 'Keyword research', completed: false },
            { id: 'seo_s4', name: 'Marketing audit', completed: false },
            { id: 'seo_s5', name: 'Citation strategy', completed: false },
            { id: 'seo_s6', name: 'Favicon check', completed: false },
            { id: 'seo_s7', name: 'Ahrefs set up', completed: false },
            { id: 'seo_s8', name: 'GA4 setup', completed: false },
            { id: 'seo_s9', name: 'GSC & XML sitemap submitted', completed: false },
            { id: 'seo_s10', name: 'GTM conversion tracking', completed: false },
            { id: 'seo_s11', name: 'HTML sitemap', completed: false },
            { id: 'seo_s12', name: 'Business schema', completed: false },
            { id: 'seo_s13', name: 'Header tag optimisation', completed: false },
        ] },
        { name: 'Strategy & content', tasks: [
            { id: 'seo_sc1', name: 'Bespoke stategy formulation', completed: false },
            { id: 'seo_sc2', name: 'Month 1 content in production', completed: false },
            { id: 'seo_sc3', name: 'Metadata updates', completed: false },
            { id: 'seo_sc4', name: 'CRO ideas', completed: false },
        ] },
        { name: 'Optimisations', tasks: [
            { id: 'seo_o1', name: 'Quick win update', completed: false },
            { id: 'seo_o2', name: 'Pagespeed optimisation', completed: false },
            { id: 'seo_o3', name: 'Citations', completed: false },
            { id: 'seo_o4', name: 'Technical SEO update', completed: false },
            { id: 'seo_o5', name: 'Month 1 content uploaded', completed: false },
        ] },
        { name: 'Reporting', tasks: [
            { id: 'seo_r1', name: 'Content upload', completed: false },
            { id: 'seo_r2', name: 'Citations', completed: false },
            { id: 'seo_r3', name: 'Editorials', completed: false },
            { id: 'seo_r4', name: 'Monthly check-in', completed: false },
        ] },
    ],
    'PPC': [
        { name: 'Setup', tasks: [
            { id: 'ppc_s1', name: 'Onboarding', completed: false },
            { id: 'ppc_s2', name: 'Marketing audit', completed: false },
            { id: 'ppc_s3', name: 'Google ads ID', completed: false },
            { id: 'ppc_s4', name: 'GA4', completed: false },
            { id: 'ppc_s5', name: 'GTM conversion tracking', completed: false },
            { id: 'ppc_s5', name: 'Conversion API setup', completed: false },
        ] },
        { name: 'Strategy & launch', tasks: [
            { id: 'ppc_sl1', name: 'Keyword research', completed: false },
            { id: 'ppc_sl2', name: 'Landing page optimisation (CRO)', completed: false },
            { id: 'ppc_sl3', name: 'Campaign setup', completed: false },
            { id: 'ppc_sl4', name: 'Launch', completed: false },
        ] },
        { name: 'Monitoring', tasks: [
            { id: 'ppc_m1', name: 'Analysis (after 14 days)', completed: false },
        ] },
        { name: 'Optimisation and reporting', tasks: [
            { id: 'ppc_or1', name: 'Further optimisations', completed: false },
            { id: 'ppc_or2', name: 'Reporting', completed: false },
        ] },
    ],
    'Meta Ads': [
        { name: 'Setup', tasks: [
            { id: 'meta_s1', name: 'Onboarding', completed: false },
            { id: 'meta_s2', name: 'Marketing audit', completed: false },
            { id: 'meta_s3', name: 'Access to meta business manager', completed: false },
            { id: 'meta_s4', name: 'Pixel installed', completed: false },
            { id: 'meta_s5', name: 'GA4', completed: false },
            { id: 'meta_s6', name: 'GTM conversion tracking', completed: false },
            { id: 'ppc_s5', name: 'Conversion API setup', completed: false },
        ] },
        { name: 'Strategy & launch', tasks: [
            { id: 'meta_sl1', name: 'Landing page optimisation (CRO)', completed: false },
            { id: 'meta_sl2', name: 'Campaign setup', completed: false },
            { id: 'meta_sl3', name: 'Launch', completed: false },
        ] },
        { name: 'Monitoring', tasks: [
            { id: 'meta_m1', name: 'Analysis (after 14 days)', completed: false },
        ] },
        { name: 'Optimisation & reporting', tasks: [
            { id: 'meta_or1', name: 'Further optimisations', completed: false },
            { id: 'meta_or2', name: 'Reporting', completed: false },
        ] },
    ],
};


// Sample initial data (simulating your master sheets with new stages and KPIs)
// This data is used only if the Firestore collection is empty.
// New clients will be added via the UI and saved directly to Firestore.
const initialClientsData = [
    {
        id: 'client1',
        name: 'Client A',
        googleDriveUrl: 'https://drive.google.com/drive/folders/YOUR_CLIENT_A_DRIVE_ID', // Example Drive URL
        services: [
            {
                type: 'Web Design',
                lookerStudioUrl: 'https://lookerstudio.google.com/embed/reporting/258a6967-7c46-4ef6-aa3b-ff2d40cea246/page/p_8jvxmorodd',
                kpis: {
                    websiteTrafficBefore: '0',
                    pageSpeedBefore: '0',
                    keywordsOnPageBefore: '0',
                    clicksBefore: '0',
                    impressionsBefore: '0',
                },
                stages: DEFAULT_SERVICE_TASKS['Web Design'].map(stage => ({
                    ...stage,
                    tasks: stage.tasks.map(task => ({ ...task, completed: false }))
                })),
            },
            {
                type: 'SEO',
                lookerStudioUrl: 'https://lookerstudio.google.com/embed/reporting/258a6967-7c46-4ef6-aa3b-ff2d40cea246/page/p_8jvxmorodd',
                kpis: {
                    websiteTrafficBefore: '1200',
                    pageSpeedBefore: '75',
                    keywordsOnPageBefore: '25',
                    clicksBefore: '150',
                    impressionsBefore: '15000',
                },
                stages: DEFAULT_SERVICE_TASKS['SEO'].map(stage => ({
                    ...stage,
                    tasks: stage.tasks.map(task => ({ ...task, completed: false }))
                })),
            },
        ],
    },
    {
        id: 'client2',
        name: 'Client B',
        googleDriveUrl: 'https://drive.google.com/drive/folders/YOUR_CLIENT_B_DRIVE_ID', // Example Drive URL
        services: [
            {
                type: 'PPC',
                lookerStudioUrl: 'https://lookerstudio.google.com/embed/reporting/258a6967-7c46-4ef6-aa3b-ff2d40cea246/page/p_8jvxmorodd',
                kpis: {
                    websiteTrafficBefore: '800',
                    pageSpeedBefore: '70',
                    keywordsOnPageBefore: '0',
                    clicksBefore: '100',
                    impressionsBefore: '10000',
                },
                stages: DEFAULT_SERVICE_TASKS['PPC'].map(stage => ({
                    ...stage,
                    tasks: stage.tasks.map(task => ({ ...task, completed: false }))
                })),
            },
            {
                type: 'Meta Ads',
                lookerStudioUrl: 'https://lookerstudio.google.com/embed/reporting/258a6967-7c46-4ef6-aa3b-ff2d40cea246/page/p_8jvxmorodd',
                kpis: {
                    websiteTrafficBefore: '1500',
                    pageSpeedBefore: '80',
                    keywordsOnPageBefore: '0',
                    clicksBefore: '200',
                    impressionsBefore: '20000',
                },
                stages: DEFAULT_SERVICE_TASKS['Meta Ads'].map(stage => ({
                    ...stage,
                    tasks: stage.tasks.map(task => ({ ...task, completed: false }))
                })),
            },
        ],
    },
];

function App() {
    const [userId, setUserId] = useState(null);
    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isClientView, setIsClientView] = useState(false);
    const [showLookerStudio, setShowLookerStudio] = useState({});

    // Admin Login States
    const [adminEmail, setAdminEmail] = useState('');
    const [adminPassword, setAdminPassword] = useState('');
    const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);
    const [loginError, setLoginError] = useState(null);

    // New client form states
    const [newClientName, setNewClientName] = useState('');
    const [newClientGoogleDriveUrl, setNewClientGoogleDriveUrl] = useState('');
    const [newClientServices, setNewClientServices] = useState([]);
    const [addClientLoading, setAddClientLoading] = useState(false);
    const [addClientError, setAddClientError] = useState(null);
    const [addClientSuccess, setAddClientSuccess] = useState(false);

    // General message box
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState('info');

    // Delete confirmation modal
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [deletingClient, setDeletingClient] = useState(false);

    // New state to track if initial auth check is complete
    const [isAuthReady, setIsAuthReady] = useState(false);

    // Function to display messages
    const showMessageBox = useCallback((msg, type = 'info') => {
        setMessage(msg);
        setMessageType(type);
        const timer = setTimeout(() => {
            setMessage(null);
            setMessageType('info');
        }, 5000);
        return () => clearTimeout(timer);
    }, []);

    // Admin Login Handler
    const handleAdminLogin = async (e) => {
        e.preventDefault();
        setLoginError(null);
        setLoading(true); // Start loading again after login attempt
        try {
            const userCredential = await signInWithEmailAndPassword(auth, adminEmail, adminPassword);
            setUserId(userCredential.user.uid);
            setIsAdminLoggedIn(true);
            showMessageBox('Logged in as admin successfully!', 'success');
            // Clear login form
            setAdminEmail('');
            setAdminPassword('');
            // NOTE: setLoading(false) is handled in the onAuthStateChanged listener now.
        } catch (error) {
            console.error("Admin login error:", error);
            setLoginError('Invalid email or password. Please check Firebase Authentication for user status.');
            showMessageBox('Login failed. Please check your credentials.', 'error');
            setLoading(false); // Stop loading on error
        }
    };

    // Admin Logout Handler
    const handleAdminLogout = async () => {
        try {
            await signOut(auth);
            setUserId(null);
            setIsAdminLoggedIn(false);
            setSelectedClient(null); // Clear selected client on logout
            setClients([]); // Clear client data
            showMessageBox('Logged out successfully.', 'info');
        } catch (error) {
            console.error("Admin logout error:", error);
            showMessageBox('Error logging out. Please try again.', 'error');
        }
    };

    // Function to handle task completion toggle
    const handleTaskToggle = useCallback(async (clientId, serviceType, stageName, taskId, currentCompleted) => {
        if (!userId || !isAdminLoggedIn) {
            showMessageBox("You must be logged in as an admin to update tasks.", "error");
            return;
        }

        // Use ADMIN_UID here instead of userId
        const adminClientRef = doc(db, `artifacts/${firebaseConfig.projectId}/users/${ADMIN_UID}/clientProjects`, clientId);
        const publicClientRef = doc(db, `artifacts/${firebaseConfig.projectId}/public_client_data`, clientId);

        console.log("Attempting to update task for client:", clientId);
        console.log("Admin private path:", adminClientRef.path);
        console.log("Public data path:", publicClientRef.path);


        let currentClientData; // For admin's private data
        let currentPublicData; // For public data

        // Optimistically update UI
        setClients(prevClients => prevClients.map(client => {
            if (client.id === clientId) {
                return {
                    ...client,
                    services: client.services.map(service => {
                        if (service.type === serviceType) {
                            return {
                                ...service,
                                stages: service.stages.map(stage => {
                                    if (stage.name === stageName) {
                                        return {
                                            ...stage,
                                            tasks: stage.tasks.map(task =>
                                                task.id === taskId ? { ...task, completed: !currentCompleted } : task
                                            )
                                        };
                                    }
                                    return stage;
                                })
                            };
                        }
                        return service;
                    })
                };
            }
            return client;
        }));

        try {
            // Fetch current admin data
            const adminDoc = await getDoc(adminClientRef);
            if (!adminDoc.exists()) throw new Error("Admin client document not found.");
            currentClientData = adminDoc.data();

            // Fetch current public data
            const publicDoc = await getDoc(publicClientRef);
            currentPublicData = publicDoc.exists() ? publicDoc.data() : null;

            // Update admin's private data
            const updatedAdminData = JSON.parse(JSON.stringify(currentClientData));
            updatedAdminData.services = updatedAdminData.services.map(service => {
                if (service.type === serviceType) {
                    service.stages = service.stages.map(stage => {
                        if (stage.name === stageName) {
                            stage.tasks = stage.tasks.map(task => {
                                if (task.id === taskId) {
                                    return { ...task, completed: !currentCompleted };
                                }
                                return task;
                            });
                        }
                        return stage;
                    });
                }
                return service;
            });
            await setDoc(adminClientRef, updatedAdminData);

            // Update public data (only relevant fields)
            if (currentPublicData) {
                const updatedPublicData = JSON.parse(JSON.stringify(currentPublicData));
                updatedPublicData.services = updatedPublicData.services.map(service => {
                    if (service.type === serviceType) {
                        // Correctly update stages and tasks within the public data
                        service.stages = service.stages.map(stage => {
                            if (stage.name === stageName) {
                                stage.tasks = stage.tasks.map(task => {
                                    if (task.id === taskId) {
                                        return { ...task, completed: !currentCompleted };
                                    }
                                    return task;
                                });
                            }
                            return stage;
                        });
                    }
                    return service;
                });
                await setDoc(publicClientRef, updatedPublicData);
            } else {
                // If public document didn't exist, create it (should ideally be created by handleAddClient)
                // For robustness, create a minimal public version if it's missing
                const serviceToUpdate = updatedAdminData.services.find(s => s.type === serviceType);
                if (serviceToUpdate) {
                    const minimalPublicData = {
                        id: updatedAdminData.id,
                        name: updatedAdminData.name,
                        googleDriveUrl: updatedAdminData.googleDriveUrl,
                        services: [
                            {
                                type: serviceToUpdate.type,
                                lookerStudioUrl: serviceToUpdate.lookerStudioUrl,
                                kpis: serviceToUpdate.kpis,
                                stages: serviceToUpdate.stages.map(stage => ({
                                    name: stage.name,
                                    tasks: stage.tasks.map(task => ({
                                        id: task.id,
                                        name: task.name,
                                        completed: task.completed
                                    }))
                                }))
                            }
                        ]
                    };
                    await setDoc(publicClientRef, minimalPublicData);
                }
            }

            setError(null);
        } catch (e) {
            console.error("Error updating task:", e);
            showMessageBox("Failed to update task. Please check your connection.", "error");
            // Revert optimistic update if error occurs
            if (currentClientData) {
                setClients(prevClients => prevClients.map(client => {
                    if (client.id === clientId) {
                        return {
                            ...client,
                            services: currentClientData.services // Revert to original admin data
                        };
                    }
                    return client;
                }));
            }
        }
    }, [userId, isAdminLoggedIn, showMessageBox]);

    // Function to handle KPI input changes
    const handleKpiChange = useCallback(async (clientId, serviceType, kpiName, value) => {
        if (!userId || !isAdminLoggedIn) {
            showMessageBox("You must be logged in as an admin to update KPIs.", "error");
            return;
        }

        // Use ADMIN_UID here instead of userId
        const adminClientRef = doc(db, `artifacts/${firebaseConfig.projectId}/users/${ADMIN_UID}/clientProjects`, clientId);
        const publicClientRef = doc(db, `artifacts/${firebaseConfig.projectId}/public_client_data`, clientId);

        console.log("Attempting to update KPI for client:", clientId);
        console.log("Admin private path:", adminClientRef.path);
        console.log("Public data path:", publicClientRef.path);

        let currentClientData; // For admin's private data
        let currentPublicData; // For public data

        // Optimistically update UI
        setClients(prevClients => prevClients.map(client => {
            if (client.id === clientId) {
                return {
                    ...client,
                    services: client.services.map(service => {
                        if (service.type === serviceType) {
                            return {
                                ...service,
                                kpis: {
                                    ...service.kpis,
                                    [kpiName]: value // Store as string
                                }
                            };
                        }
                        return service;
                    })
                };
            }
            return client;
        }));

        try {
            // Fetch current admin data
            const adminDoc = await getDoc(adminClientRef);
            if (!adminDoc.exists()) throw new Error("Admin client document not found.");
            currentClientData = adminDoc.data();

            // Fetch current public data
            const publicDoc = await getDoc(publicClientRef);
            currentPublicData = publicDoc.exists() ? publicDoc.data() : null;

            // Update admin's private data
            const updatedAdminData = JSON.parse(JSON.stringify(currentClientData));
            updatedAdminData.services = updatedAdminData.services.map(service => {
                if (service.type === serviceType) {
                    return {
                        ...service,
                        kpis: {
                            ...service.kpis,
                            [kpiName]: value // Store as string
                        }
                    };
                }
                return service;
            });
            await setDoc(adminClientRef, updatedAdminData);

            // Update public data (only relevant fields)
            if (currentPublicData) {
                const updatedPublicData = JSON.parse(JSON.stringify(currentPublicData));
                updatedPublicData.services = updatedPublicData.services.map(service => {
                    if (service.type === serviceType) {
                        return {
                            ...service,
                            kpis: {
                                ...service.kpis,
                                [kpiName]: value // Store as string
                            }
                        };
                    }
                    return service;
                });
                await setDoc(publicClientRef, updatedPublicData);
            } else {
                // If public document didn't exist, create it (should ideally be created by handleAddClient)
                const serviceToUpdate = updatedAdminData.services.find(s => s.type === serviceType);
                if (serviceToUpdate) {
                    const minimalPublicData = {
                        id: updatedAdminData.id,
                        name: updatedAdminData.name,
                        googleDriveUrl: updatedAdminData.googleDriveUrl,
                        services: [
                            {
                                type: serviceToUpdate.type,
                                lookerStudioUrl: serviceToUpdate.lookerStudioUrl,
                                kpis: serviceToUpdate.kpis,
                                stages: serviceToUpdate.stages.map(stage => ({
                                    name: stage.name,
                                    tasks: stage.tasks.map(task => ({
                                        id: task.id,
                                        name: task.name,
                                        completed: task.completed
                                    }))
                                }))
                            }
                        ]
                    };
                    await setDoc(publicClientRef, minimalPublicData);
                }
            }

            setError(null);
        } catch (e) {
            console.error("Error updating KPI:", e);
            showMessageBox("Failed to update KPI. Please check your connection.", "error");
            // Revert optimistic update if error occurs
            if (currentClientData) {
                setClients(prevClients => prevClients.map(client => {
                    if (client.id === clientId) {
                        return {
                            ...client,
                            services: currentClientData.services // Revert to original admin data
                        };
                    }
                    return client;
                }));
            }
        }
    }, [userId, isAdminLoggedIn, showMessageBox]);

    // Function to handle adding a new client
    const handleAddClient = async (e) => {
        e.preventDefault();
        setAddClientLoading(true);
        setAddClientError(null);
        setAddClientSuccess(false);
        setMessage(null);

        if (!userId || !isAdminLoggedIn) {
            setAddClientError("You must be logged in as an admin to add clients.");
            setAddClientLoading(false);
            return;
        }
        if (!newClientName.trim()) {
            setAddClientError("Client name cannot be empty.");
            setAddClientLoading(false);
            return;
        }
        if (newClientServices.length === 0) {
            setAddClientError("Please select at least one service.");
            setAddClientLoading(false);
            return;
        }
        if (!newClientGoogleDriveUrl.trim() || !newClientGoogleDriveUrl.startsWith('https://')) {
            setAddClientError("Please provide a valid Google Drive URL starting with 'https://'.");
            setAddClientLoading(false);
            return;
        }

        const invalidUrlService = newClientServices.find(service => !service.lookerStudioUrl || !service.lookerStudioUrl.startsWith('https://'));
        if (invalidUrlService) {
            setAddClientError(`Please provide a valid Looker Studio URL for ${invalidUrlService.type}. It must start with 'https://'.`);
            setAddClientLoading(false);
            return;
        }

        try {
            // Use ADMIN_UID here instead of userId
            const adminClientProjectsCollectionRef = collection(db, `artifacts/${firebaseConfig.projectId}/users/${ADMIN_UID}/clientProjects`);
            const publicClientDataCollectionRef = collection(db, `artifacts/${firebaseConfig.projectId}/public_client_data`);

            const newClientDocRef = doc(adminClientProjectsCollectionRef); // Firestore generates a unique ID

            console.log("Attempting to add new client.");
            console.log("Admin private collection path:", adminClientProjectsCollectionRef.path);
            console.log("Public data collection path:", publicClientDataCollectionRef.path);
            console.log("New client document ID (will be generated):", newClientDocRef.id);


            const clientServicesData = newClientServices.map(service => {
                // Use DEFAULT_SERVICE_TASKS to get the full structure for stages and tasks
                const stagesForService = DEFAULT_SERVICE_TASKS[service.type] ?
                    DEFAULT_SERVICE_TASKS[service.type].map(stage => ({
                        ...stage,
                        tasks: stage.tasks.map(task => ({ ...task, completed: false })) // Ensure tasks are initially not completed
                    })) : [];

                const initialKpis = {
                    websiteTrafficBefore: '0',
                    pageSpeedBefore: '0',
                    keywordsOnPageBefore: '0',
                    clicksBefore: '0',
                    impressionsBefore: '0',
                };

                return {
                    type: service.type,
                    lookerStudioUrl: service.lookerStudioUrl,
                    kpis: initialKpis,
                    stages: stagesForService,
                };
            });

            const newClientData = {
                id: newClientDocRef.id,
                name: newClientName.trim(),
                googleDriveUrl: newClientGoogleDriveUrl.trim(),
                services: clientServicesData,
            };

            // 1. Save to admin's private collection
            await setDoc(newClientDocRef, newClientData);
            console.log(`Successfully saved to admin private collection: ${newClientDocRef.path}`);


            // 2. Prepare data for public collection (only fields clients need to see)
            const publicDataForNewClient = {
                id: newClientDocRef.id,
                name: newClientName.trim(),
                googleDriveUrl: newClientGoogleDriveUrl.trim(), // Include if clients should see this
                services: clientServicesData.map(service => ({
                    type: service.type,
                    lookerStudioUrl: service.lookerStudioUrl,
                    kpis: service.kpis, // Or a subset of KPIs
                    stages: service.stages.map(stage => ({
                        name: stage.name,
                        tasks: stage.tasks.map(task => ({
                            id: task.id,
                            name: task.name,
                            completed: task.completed
                        }))
                    }))
                }))
            };
            // Save to public collection with the same ID
            await setDoc(doc(publicClientDataCollectionRef, newClientDocRef.id), publicDataForNewClient);
            console.log(`Successfully saved to public collection: ${doc(publicClientDataCollectionRef, newClientDocRef.id).path}`);


            setNewClientName('');
            setNewClientGoogleDriveUrl('');
            setNewClientServices([]);
            setAddClientSuccess(true);
            showMessageBox("Client added successfully! The page will refresh to show the new client.", "success");
        } catch (e) {
            console.error("Error adding new client:", e);
            setAddClientError(`Failed to add client: ${e.message}`);
            showMessageBox(`Error adding client: ${e.message}`, "error");
        } finally {
            setAddClientLoading(false);
        }
    };

    // Function to handle service type selection for new client
    const handleNewClientServiceChange = (serviceType, isChecked) => {
        if (isChecked) {
            setNewClientServices(prev => [...prev, { type: serviceType, lookerStudioUrl: '' }]);
        } else {
            setNewClientServices(prev => prev.filter(service => service.type !== serviceType));
        }
    };

    // Function to handle Looker Studio URL input for new client services
    const handleNewClientLookerStudioUrlChange = (serviceType, url) => {
        setNewClientServices(prev => prev.map(service =>
            service.type === serviceType ? { ...service, lookerStudioUrl: url } : service
        ));
    };

    // Function to handle client deletion
    const handleDeleteClient = async () => {
        if (!userId || !isAdminLoggedIn) {
            showMessageBox("You must be logged in as an admin to delete clients.", "error");
            return;
        }
        if (!selectedClient) {
            showMessageBox("Please select a client to delete.", "error");
            return;
        }
        setShowDeleteConfirm(true);
    };

    const confirmDeleteClient = async () => {
        setDeletingClient(true);
        setAddClientError(null);
        setMessage(null);

        if (!selectedClient) {
            showMessageBox("No client selected for deletion.", "error");
            setDeletingClient(false);
            setShowDeleteConfirm(false);
            return;
        }

        // Use ADMIN_UID here instead of userId
        const adminClientDocRef = doc(db, `artifacts/${firebaseConfig.projectId}/users/${ADMIN_UID}/clientProjects`, selectedClient);
        const publicClientDocRef = doc(db, `artifacts/${firebaseConfig.projectId}/public_client_data`, selectedClient);

        console.log("Attempting to delete client:", selectedClient);
        console.log("Admin private delete path:", adminClientDocRef.path);
        console.log("Public data delete path:", publicClientDocRef.path);

        try {
            // Delete from admin's private collection
            await deleteDoc(adminClientDocRef);
            console.log(`Successfully deleted from admin private collection: ${adminClientDocRef.path}`);

            // Delete from public collection
            await deleteDoc(publicClientDocRef);
            console.log(`Successfully deleted from public collection: ${publicClientDocRef.path}`);


            showMessageBox(`Client "${clients.find(c => c.id === selectedClient)?.name}" deleted successfully.`, "success");
            setSelectedClient(null);
        } catch (e) {
            console.error("Error deleting client:", e);
            showMessageBox(`Failed to delete client: ${e.message}`, "error");
        } finally {
                setDeletingClient(false);
                setShowDeleteConfirm(false);
            }
        };


    // Effect for Firebase authentication and initial data setup
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const clientIdFromUrl = urlParams.get('clientId');

        // Set isClientView immediately based on URL
        setIsClientView(!!clientIdFromUrl);

        let unsubscribeSnapshot = () => {}; // Initialize a no-op function for cleanup
        
        // 🚨 CRITICAL FAIL-SAFE: If Firebase is frozen, this ensures the UI loads after 3 seconds.
        const failSafeTimeout = setTimeout(() => {
            console.warn("Firebase authentication check timed out (3s). Forcing UI to load.");
            setLoading(false);
        }, 3000);

        // START FIX: Sign in anonymously for client view if not logged in
        if (clientIdFromUrl && !auth.currentUser) {
            console.log("Client ID present in URL. Attempting anonymous sign-in...");
            signInAnonymously(auth)
                .catch((e) => {
                    console.error("Anonymous sign-in failed:", e);
                    setError("Failed to authenticate client session. Please check permissions.");
                    clearTimeout(failSafeTimeout); // Clear timeout on error
                    setLoading(false); // CRITICAL: Stop loading on error
                });
        }
        // END FIX

        const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
            clearTimeout(failSafeTimeout); // Clear the timeout as soon as auth state resolves

            if (user) {
                setUserId(user.uid);
                setIsAdminLoggedIn(!user.isAnonymous); // If not anonymous, assume admin for this app's logic

                console.log("Auth state changed. User:", user.uid, "Is Anonymous:", user.isAnonymous);

                // Only proceed if auth is ready
                setIsAuthReady(true);

                // CRITICAL FIX: Use ADMIN_UID for the admin's private data path, regardless of the currently logged-in admin's UID.
                const adminClientProjectsRef = collection(db, `artifacts/${firebaseConfig.projectId}/users/${ADMIN_UID}/clientProjects`);
                const publicClientDataRef = collection(db, `artifacts/${firebaseConfig.projectId}/public_client_data`);


                if (!user.isAnonymous && !clientIdFromUrl) { // Admin view (Logged in with email/password)
                    // Check if data exists for this admin, if not, populate it
                    const querySnapshot = await getDocs(adminClientProjectsRef);
                    if (querySnapshot.empty) {
                        console.log("No existing client data found for admin. Populating with initial data...");
                        for (const clientData of initialClientsData) {
                            try {
                                await setDoc(doc(adminClientProjectsRef, clientData.id), clientData);
                                const publicData = {
                                    id: clientData.id,
                                    name: clientData.name,
                                    googleDriveUrl: clientData.googleDriveUrl,
                                    services: clientData.services.map(service => ({
                                        type: service.type,
                                        lookerStudioUrl: service.lookerStudioUrl,
                                        kpis: service.kpis,
                                        stages: service.stages.map(stage => ({
                                            name: stage.name,
                                            tasks: stage.tasks.map(task => ({ ...task, completed: false }))
                                        }))
                                    }))
                                };
                                await setDoc(doc(publicClientDataRef, clientData.id), publicData);
                            } catch (e) {
                                console.error("Error setting initial client data:", e);
                                setError("Failed to set up initial data. Check console for details.");
                                setLoading(false); // CRITICAL: Stop loading on error
                                return; // Stop if initial setup fails
                            }
                        }
                    }

                    // Listen to admin's private collection for all clients
                    unsubscribeSnapshot = onSnapshot(adminClientProjectsRef, (snapshot) => {
                        const fetchedClients = snapshot.docs.map(doc => ({
                            id: doc.id,
                            ...doc.data()
                        }));
                        setClients(fetchedClients);
                        if (fetchedClients.length > 0 && !selectedClient) {
                            setSelectedClient(fetchedClients[0].id);
                        }
                        setLoading(false); // CRITICAL: Stop loading on success
                        setError(null);
                    }, (e) => {
                        console.error("Error fetching client projects for admin view:", e);
                        // If we are getting an error here, it is likely due to the security rules
                        if (e.code === 'permission-denied') {
                             setError("Failed to load client data: Permission denied. Check that your Firestore Security Rules allow read access for authenticated users.");
                        } else {
                            setError(`Failed to load client data: ${e.message}. Please try again.`);
                        }
                        setLoading(false); // CRITICAL: Stop loading on error
                    });
                } else if (clientIdFromUrl) { // Client view (after anonymous sign-in or admin login)
                    // Listen to the specific public client document
                    const clientDocRef = doc(publicClientDataRef, clientIdFromUrl);
                    unsubscribeSnapshot = onSnapshot(clientDocRef, (docSnapshot) => {
                        if (docSnapshot.exists()) {
                            setClients([{ id: docSnapshot.id, ...docSnapshot.data() }]);
                            setSelectedClient(docSnapshot.id);
                            setError(null);
                        } else {
                            setError(`Client with ID "${clientIdFromUrl}" not found or unauthorized.`);
                            setClients([]);
                        }
                        setLoading(false); // CRITICAL: Stop loading on success/not found
                    }, (e) => {
                        console.error("Error fetching client project for client view:", e);
                        setError("Failed to load client data. Please check the URL and permissions.");
                        setLoading(false); // CRITICAL: Stop loading on error
                    });
                } else { // Fallback for unauthenticated user on base URL
                    setLoading(false);
                    setIsAuthReady(true); // Mark auth as ready for non-client view
                }
            } else {
                // If no user is authenticated (and we haven't forced anonymous login yet for client view)
                // Set loading to false so the admin login form appears
                setLoading(false);
                setIsAuthReady(true);
            }
        });

        // Cleanup function for useEffect
        return () => {
            unsubscribeAuth();
            unsubscribeSnapshot(); // Ensure snapshot listener is also unsubscribed
            clearTimeout(failSafeTimeout); // 🚨 CRITICAL: Cleanup the fail-safe timeout
        };
    }, [selectedClient, showMessageBox]); // Re-run effect if selectedClient changes


    const selectedClientData = clients.find(client => client.id === selectedClient);

    // Determine message box classes based on messageType state
    const messageBoxClasses = `p-3 rounded-lg text-sm ${
        messageType === 'error' ? 'bg-red-100 text-red-700' :
        messageType === 'success' ? 'bg-green-100 text-green-700' :
        'bg-blue-100 text-blue-700'
    }`;

    return (
        <div className="min-h-screen bg-[#030541] p-4 sm:p-6 md:p-8">
            <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg p-6 sm:p-8">
                {/* Container for Logo, Progress Tracker Title, and Client Name for uniform spacing */}
                <div className="flex flex-col items-center space-y-4 mb-8">
                    {/* Ahead Marketing Logo - Moved above title and smaller */}
                    <div className="flex justify-center">
                        <img src="https://aheadmarketing.co.uk/wp-content/uploads/2025/07/Ahead-Marketing-1.svg" alt="Ahead Marketing Logo" className="h-6" />
                    </div>

                    <h1 className="text-3xl font-bold text-center text-[#030541]">Progress tracker</h1>

                    {selectedClientData && (
                        <h2 className="text-2xl font-semibold text-center text-[#030541]">{selectedClientData.name}</h2>
                    )}
                </div>

                {/* General Message Box */}
                {message && (
                    <div className={messageBoxClasses} role="alert">
                        {message}
                    </div>
                )}

                {loading ? (
                    <div className="flex justify-center items-center h-48">
                        <div className="text-[#212121] text-xl">Loading application...</div>
                    </div>
                ) : error ? (
                    <div className="flex justify-center items-center h-48 bg-red-100 text-red-800 p-4 rounded-lg">
                        Error: {error}
                    </div>
                ) : (
                    <>
                        {/* Admin Login Form or Logout Button */}
                        {!isClientView && !isAdminLoggedIn && (
                            <div className="mt-8 p-6 bg-gray-50 rounded-xl shadow-md border border-gray-200">
                                <h2 className="text-2xl font-semibold text-[#030541] mb-4">Admin login</h2>
                                <form onSubmit={handleAdminLogin} className="space-y-4">
                                    <div>
                                        <label htmlFor="adminEmail" className="block text-[#212121] font-medium mb-1">Email:</label>
                                        <input
                                            type="email"
                                            id="adminEmail"
                                            value={adminEmail}
                                            onChange={(e) => setAdminEmail(e.target.value)}
                                            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 bg-[#F4F2E7]"
                                            placeholder="admin@example.com"
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="adminPassword" class="block text-[#212121] font-medium mb-1">Password:</label>
                                        <input
                                            type="password"
                                            id="adminPassword"
                                            value={adminPassword}
                                            onChange={(e) => setAdminPassword(e.target.value)}
                                            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:focus:border-blue-500 transition duration-200 bg-[#F4F2E7]"
                                            placeholder="********"
                                            required
                                        />
                                    </div>
                                    <button
                                        type="submit"
                                        className="w-full bg-blue-600 text-white p-3 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-200 font-semibold shadow-md"
                                    >
                                        Login
                                    </button>
                                    {loginError && (
                                        <div className="p-3 bg-red-100 text-red-700 rounded-lg text-sm" role="alert">
                                            {loginError}
                                        </div>
                                    )}
                                </form>
                            </div>
                        )}

                        {/* Admin View (visible only if isAdminLoggedIn is true) */}
                        {!isClientView && isAdminLoggedIn && (
                            <>
                                <div className="mb-6 flex flex-col sm:flex-row items-center justify-between gap-4">
                                    <div className="flex-grow w-full sm:w-auto">
                                        <label htmlFor="client-select" className="block text-[#212121] font-medium mb-2">Select client:</label>
                                        <select
                                            id="client-select"
                                            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 bg-[#F4F2E7]"
                                            value={selectedClient || ''}
                                            onChange={(e) => setSelectedClient(e.target.value)}
                                        >
                                            {clients.length === 0 ? (
                                                <option value="">No clients available</option>
                                            ) : (
                                                <>
                                                    <option value="">-- Select a client --</option>
                                                    {clients.map(client => (
                                                        <option key={client.id} value={client.id}>{client.name}</option>
                                                    ))}
                                                </>
                                            )}
                                        </select>
                                    </div>
                                    <div className="flex flex-col sm:flex-row gap-4 mt-4 sm:mt-0">
                                        <button
                                            onClick={handleDeleteClient}
                                            className="bg-red-600 text-white p-3 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition duration-200 font-semibold shadow-md"
                                            disabled={!selectedClient || deletingClient}
                                        >
                                            {deletingClient ? 'Deleting...' : 'Delete selected client'}
                                        </button>
                                        <button
                                            onClick={handleAdminLogout}
                                            className="bg-gray-600 text-white p-3 rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition duration-200 font-semibold shadow-md"
                                        >
                                            Logout
                                        </button>
                                    </div>
                                </div>

                                {/* Delete Confirmation Modal */}
                                {showDeleteConfirm && (
                                    <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex items-center justify-center z-50">
                                        <div className="bg-white p-6 rounded-lg shadow-xl max-w-sm mx-auto text-center">
                                            <h3 className="text-xl font-semibold text-[#030541] mb-4">Confirm deletion</h3>
                                            <p className="text-[#212121] mb-6">Are you sure you want to delete client "<span className="font-bold">{clients.find(c => c.id === selectedClient)?.name}</span>"? This action cannot be undone.</p>
                                            <div className="flex justify-center space-x-4">
                                                <button
                                                    onClick={() => setShowDeleteConfirm(false)}
                                                    className="bg-gray-300 text-[#212121] px-4 py-2 rounded-lg hover:bg-gray-400 transition duration-200"
                                                    disabled={deletingClient}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    onClick={confirmDeleteClient}
                                                    className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition duration-200"
                                                    disabled={deletingClient}
                                                >
                                                    {deletingClient ? 'Deleting...' : 'Delete'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Add New Client Form */}
                                <div className="mt-8 p-6 bg-blue-50 rounded-xl shadow-md border border-blue-200">
                                    <h2 className="text-2xl font-semibold text-[#030541] mb-4">Add new client</h2>
                                    <form onSubmit={handleAddClient} className="space-y-4">
                                        <div>
                                            <label htmlFor="newClientName" className="block text-[#212121] font-medium mb-1">Client name:</label>
                                            <input
                                                type="text"
                                                id="newClientName"
                                                value={newClientName}
                                                onChange={(e) => { setNewClientName(e.target.value); setAddClientSuccess(false); setAddClientError(null); }}
                                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 bg-[#F4F2E7]"
                                                placeholder="e.g., New Client Co."
                                                required
                                            />
                                        </div>
                                        <div>
                                            <label htmlFor="newClientGoogleDriveUrl" className="block text-[#212121] font-medium mb-1">Google Drive folder URL:</label>
                                            <input
                                                type="url"
                                                id="newClientGoogleDriveUrl"
                                                value={newClientGoogleDriveUrl}
                                                onChange={(e) => { setNewClientGoogleDriveUrl(e.target.value); setAddClientSuccess(false); setAddClientError(null); }}
                                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 bg-[#F4F2E7]"
                                                placeholder="e.g., https://drive.google.com/drive/folders/..."
                                                required
                                            />
                                            <small class="block text-[#212121] mt-1">Link to the client's main Google Drive folder.</small>
                                        </div>

                                        <div>
                                            <label className="block text-[#212121] font-medium mb-2">Select services:</label>
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                                                {Object.keys(SERVICE_STAGES).map(serviceType => (
                                                    <div key={serviceType} className="flex items-center">
                                                        <input
                                                            type="checkbox"
                                                            id={`service-${serviceType}`}
                                                            checked={newClientServices.some(s => s.type === serviceType)}
                                                            onChange={(e) => handleNewClientServiceChange(serviceType, e.target.checked)}
                                                            className="form-checkbox h-5 w-5 text-blue-600 rounded focus:ring-blue-500"
                                                        />
                                                        <label htmlFor={`service-${serviceType}`} className="ml-2 text-[#212121]">{serviceType}</label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        {newClientServices.length > 0 && (
                                            <div className="space-y-3 p-4 bg-blue-100 rounded-lg border border-blue-200">
                                                <h3 className="text-lg font-semibold text-[#030541] mb-2">Looker Studio URLs for selected services:</h3>
                                                {newClientServices.map(service => (
                                                    <div key={`url-${service.type}`}>
                                                        <label htmlFor={`url-${service.type}`} className="block text-[#212121] text-sm mb-1">{service.type} Looker Studio URL:</label>
                                                        <input
                                                            type="url"
                                                            id={`url-${service.type}`}
                                                            value={service.lookerStudioUrl}
                                                            onChange={(e) => handleNewClientLookerStudioUrlChange(service.type, e.target.value)}
                                                            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 bg-[#F4F2E7]"
                                                            placeholder={`e.g., https://lookerstudio.google.com/embed/reporting/...`}
                                                            required
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        <button
                                            type="submit"
                                            className="w-full bg-blue-600 text-white p-3 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-200 font-semibold shadow-md flex items-center justify-center"
                                            disabled={addClientLoading}
                                        >
                                            {addClientLoading ? (
                                                <>
                                                    Adding client...
                                                    <span className="loading-spinner ml-2"></span>
                                                </>
                                            ) : (
                                                'Add client'
                                            )}
                                        </button>

                                        {addClientError && (
                                            <div className="p-3 bg-red-100 text-red-700 rounded-lg text-sm" role="alert">
                                                Error: {addClientError}
                                            </div>
                                        )}
                                        {addClientSuccess && (
                                            <div className="p-3 bg-green-100 text-green-700 rounded-lg text-sm" role="alert">
                                                Client added successfully! The page will reload shortly.
                                            </div>
                                        )}
                                    </form>
                                </div>
                            </>
                        )}

                        {/* Client Progress Display (visible for admin if logged in and client selected, or for client view) */}
                        {(isAdminLoggedIn || isClientView) && selectedClientData ? (
                            <div className="space-y-8 mt-8">
                                {/* Google Drive Link Button - Only visible in Admin View */}
                                {!isClientView && selectedClientData.googleDriveUrl && (
                                    <div className="text-center mb-6">
                                        <a href={selectedClientData.googleDriveUrl} target="_blank" rel="noopener noreferrer"
                                           className="inline-flex items-center bg-[#D4A437] text-white p-3 rounded-lg hover:bg-[#B88F2F] focus:outline-none focus:ring-2 focus:ring-[#D4A437] focus:ring-offset-2 transition duration-200 font-semibold shadow-md">
                                            <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M13 10H7V8h6v2zm0 4H7v-2h6v2z"></path><path fillRule="evenodd" d="M7 2a2 2 0 00-2 2v12a2 2 0 002 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zM5 4h8v12H5V4z" clipRule="evenodd"></path></svg>
                                            View drive folder
                                        </a>
                                    </div>
                                )}

                                {selectedClientData.services.map(service => {
                                    const totalTasks = service.stages.reduce((sum, stage) => sum + stage.tasks.length, 0);
                                    const completedTasks = service.stages.reduce((sum, stage) =>
                                        sum + stage.tasks.filter(task => task.completed).length, 0
                                    );
                                    const progressPercentage = totalTasks > 0 ? (completedTasks / totalTasks) * 100 : 0;
                                    const serviceColor = SERVICE_COLORS[service.type] || '#030541';

                                    return (
                                        <div
                                            key={service.type}
                                            className="bg-gray-50 p-6 rounded-2xl shadow-xl"
                                            style={{ borderTop: `8px solid ${serviceColor}` }}
                                        >
                                            <h3 className="text-2xl font-bold text-[#030541] mb-4">{service.type}</h3>

                                            {/* Progress Bar */}
                                            <div className="mb-4">
                                                <div className="w-full bg-gray-200 rounded-full h-4">
                                                    <div
                                                        className="h-4 rounded-full transition-all duration-500 ease-out"
                                                        style={{ width: `${progressPercentage}%`, backgroundColor: serviceColor }}
                                                    ></div>
                                                </div>
                                                <p className="text-sm text-[#212121] mt-2 text-right">
                                                    {completedTasks} of {totalTasks} tasks completed ({progressPercentage.toFixed(0)}%)
                                                </p>
                                            </div>

                                            {/* Baseline KPIs - Conditionally rendered */}
                                            {service.type !== 'Web Design' && (
                                                <div className="mb-6 border-t border-gray-200 pt-4">
                                                    <h4 className="text-lg font-semibold text-[#030541] mb-3">Baseline KPIs (before campaign)</h4>
                                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                        {service.kpis && (
                                                            <>
                                                                <div>
                                                                    <label className="block text-[#212121] text-sm mb-1">Website traffic:</label>
                                                                    <input
                                                                        type="text"
                                                                        value={service.kpis.websiteTrafficBefore}
                                                                        onChange={(e) => handleKpiChange(selectedClientData.id, service.type, 'websiteTrafficBefore', e.target.value)}
                                                                        className="w-full p-2 border border-gray-300 rounded-md bg-[#F4F2E7]"
                                                                        disabled={isClientView}
                                                                    />
                                                                </div>
                                                                <div>
                                                                    <label className="block text-[#212121] text-sm mb-1">Page speed score (0-100):</label>
                                                                    <input
                                                                        type="text"
                                                                        value={service.kpis.pageSpeedBefore}
                                                                        onChange={(e) => handleKpiChange(selectedClientData.id, service.type, 'pageSpeedBefore', e.target.value)}
                                                                        className="w-full p-2 border border-gray-300 rounded-md bg-[#F4F2E7]"
                                                                        disabled={isClientView}
                                                                    />
                                                                </div>
                                                                {service.type === 'SEO' && (
                                                                    <div>
                                                                        <label className="block text-[#212121] text-sm mb-1">Keywords on page 1:</label>
                                                                        <input
                                                                            type="text"
                                                                            value={service.kpis.keywordsOnPageBefore}
                                                                            onChange={(e) => handleKpiChange(selectedClientData.id, service.type, 'keywordsOnPageBefore', e.target.value)}
                                                                            className="w-full p-2 border border-gray-300 rounded-md bg-[#F4F2E7]"
                                                                            disabled={isClientView}
                                                                        />
                                                                    </div>
                                                                )}
                                                                <div>
                                                                    <label className="block text-[#212121] text-sm mb-1">Clicks:</label>
                                                                    <input
                                                                        type="text" // Ensure this is type="text"
                                                                        value={service.kpis.clicksBefore}
                                                                        onChange={(e) => handleKpiChange(selectedClientData.id, service.type, 'clicksBefore', e.target.value)}
                                                                        className="w-full p-2 border border-gray-300 rounded-md bg-[#F4F2E7]"
                                                                        disabled={isClientView}
                                                                    />
                                                                </div>
                                                                <div>
                                                                    <label className="block text-[#212121] text-sm mb-1">Impressions:</label>
                                                                    <input
                                                                        type="text" // Ensure this is type="text"
                                                                        value={service.kpis.impressionsBefore}
                                                                        onChange={(e) => handleKpiChange(selectedClientData.id, service.type, 'impressionsBefore', e.target.value)}
                                                                        className="w-full p-2 border border-gray-300 rounded-md bg-[#F4F2E7]"
                                                                        disabled={isClientView}
                                                                    />
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            )}


                                            {/* Stages and Tasks */}
                                            <div className="space-y-5 border-t border-gray-200 pt-4">
                                                {SERVICE_STAGES[service.type].map(stageName => {
                                                    const stage = service.stages.find(s => s.name === stageName);
                                                    if (!stage || stage.tasks.length === 0) {
                                                        return null;
                                                    }
                                                    return (
                                                        <div key={stage.name}>
                                                            <h4 className="text-lg font-semibold text-[#030541] mb-2 border-b pb-1">
                                                                {stage.name}
                                                            </h4>
                                                            <ul className="space-y-2">
                                                                {stage.tasks.map(task => (
                                                                    <li key={task.id} className="flex items-center">
                                                                        <input
                                                                            type="checkbox"
                                                                            id={`task-${task.id}`}
                                                                            checked={task.completed}
                                                                            onChange={() => handleTaskToggle(selectedClientData.id, service.type, stage.name, task.id, task.completed)}
                                                                            className="form-checkbox h-5 w-5 text-blue-600 rounded focus:ring-blue-500"
                                                                            disabled={isClientView}
                                                                        />
                                                                        <label
                                                                            htmlFor={`task-${task.id}`}
                                                                            className={`ml-3 text-base ${task.completed ? 'line-through text-gray-500' : 'text-[#212121]'}`}
                                                                        >
                                                                            {task.name}
                                                                        </label>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    );
                                                })}
                                            </div>

                                            {/* Looker Studio Integration */}
                                            {service.lookerStudioUrl && (
                                                <div className="mt-6 border-t border-gray-200 pt-4">
                                                    <button
                                                        onClick={() => setShowLookerStudio(prev => ({ ...prev, [service.type]: !prev[service.type] }))}
                                                        className="bg-[#030541] hover:bg-[#02032F] text-white font-bold py-2 px-4 rounded-lg transition duration-200 shadow-md hover:shadow-lg"
                                                    >
                                                        {showLookerStudio[service.type] ? 'Hide report' : 'Show report'}
                                                    </button>
                                                    {showLookerStudio[service.type] && (
                                                        <div className="mt-4 rounded-lg overflow-hidden shadow-md">
                                                            <iframe
                                                                width="100%"
                                                                height="600"
                                                                src={service.lookerStudioUrl}
                                                                frameBorder="0"
                                                                style={{ border: 0 }}
                                                                allowFullScreen
                                                                sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
                                                                title={`${service.type} Performance Report`}
                                                            ></iframe>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            // Message when no client is selected in admin view, or if client view URL is invalid
                            (!isClientView && isAdminLoggedIn) ? (
                                <p className="text-center text-[#212121] mt-8">Select a client from the dropdown to view their progress.</p>
                            ) : (
                                // This block will show if not logged in as admin and not a valid client view URL
                                <p className="text-center text-[#212121] mt-8">Please log in as an admin, or access via a client-specific URL.</p>
                            )
                        )}
                        <div className="mt-8 text-center text-[#212121] text-sm">
                            Your User ID: {userId || 'Not Authenticated'}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default App;